import Vue from 'vue'
import Vuex from 'vuex'

//modules
import application from "./application";
import user from "./user";
import permission from "./permission";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    application,
    user,
    permission,
  }
})
